import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { WrappingSerializer3cq24ex5vrdbg as WrappingSerializer } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Companion_instance17v8p6g2424o4 as Companion_instance,
  get_kind27kjvyfnc9an8 as get_kind,
  get_type3f1sl153qhh1c as get_type,
  get_nullable1f61etx34dvfo as get_nullable,
  get_annotation27eynvnd00ffx as get_annotation,
  get_handlesField2upaii4zzjnxm as get_handlesField,
  size1hf9cj08wgoyn as size,
  get_basePriority3aha966bwjyn2 as get_basePriority,
  priority7vn90mx06311 as priority,
  Generator1qrulkrel7e5m as Generator,
} from './FormRenderer.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function WrappingSerializer$inner$ref(p0) {
  var l = (_this__u8e3s4) => p0.f3u(_this__u8e3s4);
  l.callableName = 'inner';
  return l;
}
var WrapperViewRendererClass;
function WrapperViewRenderer() {
  if (WrapperViewRendererClass === VOID) {
    class $ {
      constructor() {
        this.re1_1 = 'Wrapper';
      }
      k20() {
        return this.re1_1;
      }
      ddu(module_0, selector) {
        var tmp = selector.edu_1;
        return tmp instanceof WrappingSerializer();
      }
      ndu(module_0, selector) {
        var tmp = selector.edu_1;
        var innerSer = tmp instanceof WrappingSerializer() ? tmp : THROW_CCE();
        var inner = module_0.zdt(selector.copyChangingType(innerSer.d3u()));
        var tmp_0 = Companion_instance;
        var tmp_1 = inner.p1();
        var tmp_2 = inner.uds();
        return tmp_0.idx(module_0, this, selector, tmp_1, tmp_2, ($this$ViewRenderer, field, mutable) => {
          var tmp = inner.tds();
          return tmp($this$ViewRenderer, field, lens(mutable, WrappingSerializer$inner$ref(innerSer)));
        });
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).f94 = get_type;
    protoOf($).pdu = get_nullable;
    protoOf($).qdu = get_annotation;
    protoOf($).uds = get_handlesField;
    protoOf($).idu = size;
    protoOf($).cdu = get_basePriority;
    protoOf($).rdu = priority;
    initMetadataForObject($, 'WrapperViewRenderer', VOID, VOID, [Generator()]);
    WrapperViewRendererClass = $;
  }
  return WrapperViewRendererClass;
}
var WrapperViewRenderer_instance;
function WrapperViewRenderer_getInstance() {
  return WrapperViewRenderer_instance;
}
//region block: init
WrapperViewRenderer_instance = new (WrapperViewRenderer())();
//endregion
//region block: exports
export {
  WrapperViewRenderer_instance as WrapperViewRenderer_instance1rgnfqet7vbtz,
};
//endregion

//# sourceMappingURL=WrapperViewRenderer.mjs.map
